import { BrandCard } from '@seek/branding-assets';
import { Box } from 'braid-design-system';
import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { BrandingAlert } from 'src/app/views/components/BrandingAlert';
import { EditFlowDataContext } from 'src/app/views/context/cajaFlowData';
import { ContentLoader } from 'src/app/views/shared/ContentLoader';
import type AppState from 'src/types/appState';

export const BrandingReadOnlyView = () => {
  const { brand, isConfidential } = useSelector(
    (state: AppState) => ({
      brand: state.formData.brand,
      isConfidential: state.formData.isConfidential,
    }),
    shallowEqual,
  );

  const { loading } = useContext(EditFlowDataContext);

  return (
    <>
      {isConfidential ? (
        <BrandingAlert />
      ) : (
        <Box style={{ width: '50%' }}>
          <ContentLoader loading={loading} lines={[281]} height={261}>
            <BrandCard brand={brand} showBrandId={false} />
          </ContentLoader>
        </Box>
      )}
    </>
  );
};
